// extracted by mini-css-extract-plugin
var _1 = "AIGretaLoader-moduleoverlay__sYzbh";
var _2 = "AIGretaLoader-modulepill__B7TWR";
var _3 = "AIGretaLoader-moduletext__sZhOD";
export { _1 as "overlay", _2 as "pill", _3 as "text" }
